// You can customize the template with the help of this file
/*eslint-disable */
//Template config options
const { REACT_APP_MARCA_BLANCA,REACT_APP_VERSION, REACT_APP_RECAPTCHA_KEY } = process.env;
const AppVersion = REACT_APP_VERSION
const themeConfigEuroaffiliatiLocal = {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'http://local.euroaffiliati.com/',
    djangoBaseUrl:'http://api.local.euroaffiliati.com/'
  }
}
const themeConfigLocalDev = {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'http://localhost:3000/',     // Dev server con hot reload
    djangoBaseUrl:'http://localhost:3000/'     // Proxy a Django via package.json
  }
}
const themeConfigEuroaffiliatiDevelop = {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'http://10.132.15.206:3000/',
    djangoBaseUrl:'http://10.132.15.206:8000/'
    // reactBaseUrl:'http://localhost:3000/',
    // djangoBaseUrl:'http://localhost:8000/'
  }
}
const themeConfigEuroaffiliatiDevelop2= {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    // reactBaseUrl:'http://dev.euroaffiliati.com/',
    // djangoBaseUrl:'http://preprod.euroaffiliati.com/'
    reactBaseUrl:'https://lite.euroaffiliati.com/',
    djangoBaseUrl:'https://lite-api.euroaffiliati.com/'
  }
}
const themeConfigEuroaffiliatiTest = {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://dev.euroaffiliati.com/',
    djangoBaseUrl:'https://portal-backend-staging-924576904716.europe-west1.run.app/'
  }
}

const themeConfigEuroaffiliati = {
  app: {
    appName: 'EuroAffiliati',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl: 'https://apq.euroaffiliati.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigAffiliateRevolution = {
  app: {
    appName: 'AffiliateRevolution',
    appLogoImage: require('@src/assets/images/logo/affiliatrevolution/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliatrevolution/logo.svg').default,
    appLandingPage: 'https://comparatore.affiliaterevolution.network/',
    AppVersion: AppVersion,
    company: 'AREV MEDIA LLC',
    companyAbbr: 'AREV MEDIA LLC',
    companyAddress: '30 N Gould - Ste 100 - Sheridan, WY 82801',
    companyEmail: 'info@affiliaterevolution.com',
    companyCif: '61-2079498',
    companyWeb: 'https://affiliaterevolution.net/'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.affiliaterevolution.network/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigBetmedia = {
  app: {
    appName: 'MiTipster',
    appLogoImage: require('@src/assets/images/logo/betmedia/scritta.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/betmedia/logo.png').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.mitipster.com/',
    djangoBaseUrl:'https://app.mitipster.com/'
  }
}
const themeConfigDeally = {
  app: {
    appName: 'Deally',
    appLogoImage: require('@src/assets/images/logo/deally/scritt-deally.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/deally/logo-deally.svg').default,
    appLandingPage: 'https://www.comparatore-deally.eu/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.deally.eu/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigGamingAffiliation = {
  app: {
    appName: 'GamingAffiliation',
    appLogoImage: require('@src/assets/images/logo/gaffiliation/scrittaGA.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/gaffiliation/logoGA.svg').default,
    appLandingPage: 'https://comparabonus-ga.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.gamingaffiliation.it/',
    djangoBaseUrl:'https://app.gamingaffiliation.it/'
  }
}
const themeConfigBrasiliaConnect = {
  app: {
    appName: 'BrasiliaConnect',
    appLogoImage: require('@src/assets/images/logo/brasiliaconnect/brasiliaconnect.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/brasiliaconnect/logo.png').default,
    appLandingPage: 'https://comparador.brasiliaconnect.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.brasiliaconnect.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigAffiliaBuzz = {
  app: {
    appName: 'AffiliaBuzz',
    appLogoImage: require('@src/assets/images/logo/affiliabuzz/logo.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliabuzz/scritta.png').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.affiliabuzz.com/',
    djangoBaseUrl:'https://app.affiliabuzz.com/'
  }
} 
const themeConfigTipsterUtility = {
  app: {
    appName: 'TipsterUtility',
    appLogoImage: require('@src/assets/images/logo/tipsterutility/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/tipsterutility/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.tipsterutility.com/',
    djangoBaseUrl:'https://app.tipsterutility.com/'
  }
}
const themeConfigAffiliateAccess= {
  app: {
    appName: 'AffiliateAccess',
    appLogoImage: require('@src/assets/images/logo/affiliateaccess/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliateaccess/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://apq.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigTylty= {
  app: {
    appName: 'Tylty',
    appLogoImage: require('@src/assets/images/logo/tylty/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/tylty/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Tylty Company',
    companyAbbr: 'Tylty',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://tylty.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigAffiliSearch= {
  app: {
    appName: 'AffiliSearch',
    appLogoImage: require('@src/assets/images/logo/affiliateaccess/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliateaccess/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'AffiliSearch',
    companyAbbr: 'AffiliSearch',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://affilisearch.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigFm20= {
  app: {
    appName: 'Fm20',
    appLogoImage: require('@src/assets/images/logo/fm20/scritta.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/fm20/logo.png').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Fm20',
    companyAbbr: 'Fm20',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://fm20.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigMonsterAffiliates= {
  app: {
    appName: 'MyMonsterAffiliates',
    appLogoImage: require('@src/assets/images/logo/mymonsteraffiliate/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/mymonsteraffiliate/logo.svg').default,
    appLandingPage: 'https://www.playnow.games/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://mymonsteraffiliates.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}

const themeConfigFivestarAffiliates = {
  app: {
    appName: 'FivestarsAffiliates',
    appLogoImage: require('@src/assets/images/logo/fivestaraffiliates/scritta.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/fivestaraffiliates/logo.jpg').default,
    appLandingPage: 'https://comparatore.fivestarsaffiliates.com/',
    AppVersion: AppVersion,
    company: 'CTIMETECH LIMITED',
    companyAbbr: 'CTIMETECH',
    companyAddress: '9 Hulsewood Close, Dartford, England DA2 7AD, Sic Codes: 73110',
    companyEmail: 'info@fivestarsaffiliates.com',
    companyCif: '15314232',
    companyWeb: 'www.fivestarsaffiliates.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://5staraff.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}


const themeConfigBig4partners= {
  app: {
    appName: 'Big4partners',
    appLogoImage: require('@src/assets/images/logo/big4partners/scritta.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliateaccess/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://big4partners.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigSuperaffiliate= {
  app: {
    appName: 'Superaffiliate',
    appLogoImage: require('@src/assets/images/logo/affiliateaccess/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliateaccess/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://superaffiliatehub.affiliateaccess.com/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}

const themeConfigLite = {
  app: {
    appName: 'EuroAffilite',
    appLogoImage: require('@src/assets/images/logo/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Full Moon Trading S.L.',
    companyAbbr: 'FMT',
    companyAddress: 'Calle Ferraz 78 - 3ª planta, 28008, Madrid - Spain',
    companyEmail: 'support@euroaffiliati.com',
    companyCif: 'B87508867',
    companyWeb: 'www.euroaffiliati.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://affilite.web.app/',
    djangoBaseUrl:'https://portal-backend-staging-924576904716.europe-west1.run.app/'
  }
}

const themeConfigTipaffiliation = {
  app: {
    appName: 'TipAffiliation',
    appLogoImage: require('@src/assets/images/logo/tipaffiliation/logo.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/tipaffiliation/logosmall.png').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'TipAffiliation',
    companyAbbr: 'TA',
    companyAddress: 'Riviera di Chiaia, 256 80121 - Napoli, Italy',
    companyEmail: 'tipaffiliation@gmail.com',
    companyCif: '0000000000',
    companyWeb: 'www.tipaffiliation.com'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: true,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://tipaffiliation.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigRitemood = {
  app: {
    appName: 'Ritemood',
    appLogoImage: require('@src/assets/images/logo/ritemood/logo.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/ritemood/iso.png').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Ritemood',
    companyAbbr: 'TA',
    companyAddress: 'ritemood',
    companyEmail: 'info@ritemood.com',
    companyCif: '0000000000',
    companyWeb: 'www.ritemood.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://ritemood.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigAllAffiliates= {
  app: {
    appName: 'AllAffiliates',
    appLogoImage: require('@src/assets/images/logo/allaffiliates/ColHeader.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/allaffiliates/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'AllAffiliates',
    companyAbbr: 'TA',
    companyAddress: 'allaffiliates',
    companyEmail: 'info@allaffiliates.com',
    companyCif: '0000000000',
    companyWeb: 'www.allaffiliates.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://allaffiliates.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigPhillip= {
  app: {
    appName: 'Phillip',
    appLogoImage: require('@src/assets/images/logo/affiliateaccess/scritta.svg').default,
    appLogoSmallImage: require('@src/assets/images/logo/affiliateaccess/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'Phillip',
    companyAbbr: 'TA',
    companyAddress: 'Phillip',
    companyEmail: 'info@phillip.com',
    companyCif: '0000000000',
    companyWeb: 'www.phillip.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://phillip.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
const themeConfigA2bGroup= {
  app: {
    appName: 'A2BGroup',
    appLogoImage: require('@src/assets/images/logo/a2bgroup/scritta.png').default,
    appLogoSmallImage: require('@src/assets/images/logo/a2bgroup/logo.svg').default,
    appLandingPage: 'https://www.bonuswelcome.com/',
    AppVersion: AppVersion,
    company: 'A2B Group',
    companyAbbr: 'A2BGroup',
    companyAddress: 'A2BGroup',
    companyEmail: 'support@a2bgroup.com',
    companyCif: '0000000000',
    companyWeb: 'www.a2bgroup.com'
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  domain: {
    reactBaseUrl:'https://a2bgroup.web.app/',
    djangoBaseUrl:'https://portal-backend-924576904716.europe-west1.run.app/'
  }
}
let themeConfig = themeConfigEuroaffiliatiTest;
if (REACT_APP_MARCA_BLANCA === 'LocalDev') {
  themeConfig = themeConfigLocalDev;
}
if (REACT_APP_MARCA_BLANCA === 'EuroAffiliatiLocal') {
  themeConfig = themeConfigEuroaffiliatiLocal;
}
if (REACT_APP_MARCA_BLANCA === 'EuroaffiliatiDevelop2') {
  themeConfig = themeConfigEuroaffiliatiDevelop2;
}
if (REACT_APP_MARCA_BLANCA === 'EuroAffiliatiDevelop') {
  themeConfig = themeConfigEuroaffiliatiDevelop;
}
if (REACT_APP_MARCA_BLANCA === 'EuroaffiliatiTestGAE') {
  themeConfig = themeConfigEuroaffiliatiTestGAE;
}
if ( REACT_APP_MARCA_BLANCA === 'EuroAffiliatiAU') {
  themeConfig = themeConfigEuroaffiliatiAU;
}
if ( REACT_APP_MARCA_BLANCA === 'EuroAffiliatiTest') {
  themeConfig = themeConfigEuroaffiliatiTest;
}
if (REACT_APP_MARCA_BLANCA === 'EuroAffiliati') {
  themeConfig = themeConfigEuroaffiliati;
}
if (REACT_APP_MARCA_BLANCA === 'Deally') {
  themeConfig = themeConfigDeally;
}
if (REACT_APP_MARCA_BLANCA === 'GamingAffiliation') {
  themeConfig = themeConfigGamingAffiliation;
}
if (REACT_APP_MARCA_BLANCA === 'TipsterUtility') {
  themeConfig = themeConfigTipsterUtility;
}
if (REACT_APP_MARCA_BLANCA === 'AffiliateAccess') {
  themeConfig = themeConfigAffiliateAccess;
}
if (REACT_APP_MARCA_BLANCA === 'Betmedia') {
  themeConfig = themeConfigBetmedia;
}
if (REACT_APP_MARCA_BLANCA === 'AffiliateRevolution') {
  themeConfig = themeConfigAffiliateRevolution;
}
if (REACT_APP_MARCA_BLANCA === 'MyMonsterAffiliates') {
  themeConfig = themeConfigMonsterAffiliates;
}
if (REACT_APP_MARCA_BLANCA === 'XyzNet') {
  themeConfig = themeConfigXyzNet;
}
if (REACT_APP_MARCA_BLANCA === 'FreedomLegacy') {
  themeConfig = themeConfigFreedomLegacy;
}
if (REACT_APP_MARCA_BLANCA === 'BrasiliaConnect') {
  themeConfig = themeConfigBrasiliaConnect;
}
if (REACT_APP_MARCA_BLANCA === 'AffiliaBuzz') {
  themeConfig = themeConfigAffiliaBuzz;
}
if (REACT_APP_MARCA_BLANCA === 'FivestarsAffiliates') {
  themeConfig = themeConfigFivestarAffiliates;
}
if (REACT_APP_MARCA_BLANCA === 'Fm20') {
  themeConfig = themeConfigFm20;
}
if (REACT_APP_MARCA_BLANCA === 'Tylty') {
  themeConfig = themeConfigTylty;
}
if (REACT_APP_MARCA_BLANCA === 'Fm20') {
  themeConfig = themeConfigFm20;
}
if (REACT_APP_MARCA_BLANCA === 'EuroaffiliatiAqq') {
  themeConfig = themeConfigEuroaffiliatiAqq;
}
if (REACT_APP_MARCA_BLANCA === 'AffiliSearch') {
  themeConfig = themeConfigAffiliSearch;
}
if (REACT_APP_MARCA_BLANCA === 'Big4partners') {
  themeConfig = themeConfigBig4partners;
}
if (REACT_APP_MARCA_BLANCA === 'Superaffiliate') {
  themeConfig = themeConfigSuperaffiliate;
}
if (REACT_APP_MARCA_BLANCA === 'Lite') {
  themeConfig = themeConfigLite;
}
if (REACT_APP_MARCA_BLANCA === 'TipAffiliation') {
  themeConfig = themeConfigTipaffiliation;
}
if (REACT_APP_MARCA_BLANCA === 'Ritemood') {
  themeConfig = themeConfigRitemood;
}
if (REACT_APP_MARCA_BLANCA === 'AllAffiliates') {
  themeConfig = themeConfigAllAffiliates;
}
if (REACT_APP_MARCA_BLANCA === 'Phillip') {
  themeConfig = themeConfigPhillip;
}
if (REACT_APP_MARCA_BLANCA === 'A2BGroup') {
  themeConfig = themeConfigA2bGroup;
}

export default themeConfig;
